export default __webpack_public_path__ + "static/font-f9af664cbee6bfa0ed1de159cbf27f4e.eot";